export const MESSAGE_FLOW = Object.freeze({
  "*": "Inbound & Outbound",
  inbound: "Inbound",
  outbound: "Outbound",
});

export default {};
